import _ from 'lodash'
import React  from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import marked from 'marked'
import { addTargetBlank } from 'src/helpers'

import { PROP_TYPES, MESSAGE_SENDER } from 'widget/constants'
import { MessageBubble } from 'widget/components/common'

class Message extends React.PureComponent {
  render() {
    const { message, avatarUser, avatarBot, speechBubbles } = this.props

    const text = addTargetBlank(message.get('text'))
    const html = marked.parse(text, { sanitize: false })
    if (_.isEmpty(html)) return null

    let isUser = message.get('sender') === MESSAGE_SENDER.USER
    let avatar = isUser ? avatarUser : avatarBot
    let label = isUser ? 'you said' : 'the bot said'


    return (
      <Container isUser={isUser}>
        {
          avatar &&
          message.get('showAvatar') &&
          <Avatar src={avatar} isUser={isUser} alt="" role="presentation"/>
        }
        <MessageContainer isUser={isUser} speechBubbles={speechBubbles}>
          <MessageText dangerouslySetInnerHTML={{ __html: html }} aria-label={label} role="alert"/>
          <MessageTimestamp>
            {(new Date(message.get('timestamp'))).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
          </MessageTimestamp>
        </MessageContainer>
      </Container>
    )
  }
}

Message.propTypes = {
  message: PROP_TYPES.MESSAGE,
  avatar: PropTypes.string,
  speechBubbles: PropTypes.bool
}

export default Message

const Container = styled.div`
  font-size: var(--messageFontSize);
  display: flex;
  align-items: flex-start;
  flex-direction: ${props => props.isUser ? 'row-reverse' : 'row'};
  margin: 0px 3px;
  word-wrap: break-word;
  a {
    color: ${props => props.theme.linkColor};
  }
`

const Avatar = styled.img`
  max-width: 40px;
  width: 40px;
  height: 40px;
  margin-${props => props.isUser ? 'left' : 'right'}: 5px;
`

const MessageTimestamp = styled.div`
  margin-top: 0.7em;
  font-size: 0.7em;
`

const MessageContainer = styled(MessageBubble)`

background-color: ${props =>
    props.speechBubbles !== false // checking explicitly for false to allow for undefined value
      ? props.isUser
        ? `var(--clr-grey-7-to-black, #f0f0f0)`
        : `var(--clr-grey-7-to-text, #f0f0f0)`
      : 'transparent'};
  color: var(--clr-grey-4-to-white, #2b2b2b);
  ${props => props.isUser ? 'margin-left: auto;' : '' }

  ${({isUser, theme}) => isUser ? theme.user_msg_container_css : theme.bot_msg_container_css};
`

const MessageText = styled.div`
  & > p {
    margin-top: 0;
  }
`



// WEBPACK FOOTER //
// ./src/ChatWidget/components/Messages/Message.js